import { QueryHookOptions, useLazyQuery } from '@apollo/client';
import { GET_REVIEW_ORDER_DETAILS } from '@frontend/applications/ProductFulfillmentApp/queries/getReviewOrderDetailsQuery';
import { GetReviewOrderDetails, GetReviewOrderDetailsVariables } from '@frontend/applications/ProductFulfillmentApp/queries/types/GetReviewOrderDetails';

type IOptions = QueryHookOptions<GetReviewOrderDetails, GetReviewOrderDetailsVariables>;

export const useGetReviewOrderDetails = (options: IOptions = {}) => {
  const [
    fetchReviewOrderDetails,
    {
      loading, data, error, refetch, fetchMore,
    }] = useLazyQuery<GetReviewOrderDetails, GetReviewOrderDetailsVariables>(GET_REVIEW_ORDER_DETAILS, options);

  return {
    fetchReviewOrderDetails,
    isReviewOrderDetailsLoading: loading,
    reviewOrderDetailsResp: data?.reviewOrderDetailsByIds,
    reviewOrderDetailsError: error,
    refetchReviewOrderDetails: refetch,
    fetchMoreReviewOrderDetails: fetchMore,
  };
};
